<template>
    <div class="file-range" v-if="updateLoading">
        <div class="fileRom" :class="fileLoading && file && isShow ? 'loadingOk' : ''">
            <div class="fileItem loadingImgAn">
                <div class="file_icon">
                    <svg-icon iconClass="txt" class="file" v-if="fileLoading"></svg-icon>
                    <svg-icon iconClass="loading" class="loadingSvg" v-else></svg-icon>
                </div>

                <div class="file_content">

                    <div class="file_name u-line-1">{{  file.filename }}</div>
                    
                    <div v-if="isShow">
                        <div class="file_size" v-if="fileLoading && file && !updateError">
                            {{ file.filename.split('.').pop().toUpperCase() }} <span>{{ formattedFileSize(file.size) }}</span>
                        </div>
                        <div class="file_size" v-else>
                            <span v-if="!updateError">上传中...</span>
                            <span class="error u-line-1" v-else>{{ updateError }}</span>
                        </div>
                    </div>

                </div>

                <div v-if="isShow" class="file_del" :class="updateError ? 'errorText' : ''" @click="delFile()">
                    <svg-icon iconClass="del1" class="del"></svg-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {formatFileSizePrecise} from '@/utils/fileValidator'
export default {
    name: 'FileUpload',
    props: {
        file: {
            type: Object,
            default: () => ({})
        },
        fileLoading: {
            type: Boolean,
            default: false
        },
        updateLoading: {
            type: Boolean,
            default: false
        },
        updateError: {
            type: String|Boolean,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        delFile() {
            this.$emit('delete-file')
        },
        formattedFileSize(size){
            return formatFileSizePrecise(size)
        }
    }
}
</script>

<style lang="scss" scoped>
.file-range {
    padding: 0 0 14px;

    .fileRom {
        background-color: var(--tech-btn-gray);
        border-radius: 12px;
        width: 30%;
        min-width: 200px;
        transition: background-color 0.3s;
        position: relative;
        transition: box-shadow 0.2s ease-in-out;
    }

    .loadingOk {
        &:hover {
            cursor: pointer;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

            .file_del {
                opacity: 1;
            }
        }
    }

    .fileItem {
        align-items: center;
        padding: 8px;
        display: flex;
        position: relative;

        .file_icon {
            display: flex;
            align-items: center;
            font-size: 32px;
            width: 32px;
            height: 32px;
            flex-shrink: 0;
        }

        .file_content {
            min-width: 0;

            .file_name {
                color: #262626;
                min-height: 20px;
                margin: 0;
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                flex: 1;
            }

            .file_size {
                font-size: 12px;
                color: var(--tech-text-muted);

                .error {
                    color: #e53535;
                    display: block;
                }
            }
        }

        .file_del {
            z-index: 1;
            opacity: 0;
            will-change: opacity;
            cursor: pointer;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            width: 20px;
            height: 20px;
            transition: opacity 0.2s ease-in-out;
            display: flex;
            position: absolute;
            top: -5px;
            right: -5px;
            box-shadow: 0 1px 2px rgba(148, 147, 147, 0.25),
                inset 0 0 0 0.5px #ededed;
        }

        .errorText {
            background-color: #e53535;
            box-shadow: 0 1px 2px rgba(148, 147, 147, 0.25);

            svg {
                color: #fff;
            }
        }
    }
}

.update {
    color: #333;
    font-size: 28px;
}

.file {
    font-size: 25px;
}

.loadingSvg {
    color: #636e72;
    font-size: 25px;
}

.del {
    font-size: 60%;
    color: #636e72;
}

.file-input {
    display: none;
}
</style>
